"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchRootComponent = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _actions = require("./actions");

var _selectors = require("./selectors");

var _FetchReadyStateRenderer = _interopRequireDefault(require("./FetchReadyStateRenderer"));

var _ReadyState = _interopRequireDefault(require("./ReadyState"));

var _isSameLocation = _interopRequireDefault(require("./isSameLocation"));

var FetchRootContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FetchRootContainer, _Component);

  function FetchRootContainer(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, FetchRootContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FetchRootContainer).call(this, props, context));
    _this.state = _this.getInitialState();
    return _this;
  }

  (0, _createClass2.default)(FetchRootContainer, [{
    key: "getInitialState",
    value: function getInitialState() {
      var readyState = this.props.readyState;
      return {
        readyState: readyState
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var forceInitialFetch = this.props.forceInitialFetch;
      var readyState = this.state.readyState;

      if (readyState === _ReadyState.default.PENDING || forceInitialFetch) {
        this.fetchRouteData();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var previousRouterProps = this.props.routerProps;
      var nextReadyState = nextProps.readyState,
          nextRouterProps = nextProps.routerProps;
      var previousLocation = previousRouterProps.location;
      var nextLocation = nextRouterProps.location;

      if ((0, _isSameLocation.default)(previousLocation, nextLocation)) {
        this.setState({
          readyState: nextReadyState
        });
      } else {
        this.setState({
          readyState: _ReadyState.default.PENDING
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var readyState = this.state.readyState;

      if (readyState === _ReadyState.default.PENDING) {
        this.fetchRouteData();
      }
    }
  }, {
    key: "fetchRouteData",
    value: function fetchRouteData() {
      var _this$props = this.props,
          onFetchRouteData = _this$props.onFetchRouteData,
          routerProps = _this$props.routerProps;
      onFetchRouteData(routerProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          error = _this$props2.error,
          renderFailure = _this$props2.renderFailure,
          renderSuccess = _this$props2.renderSuccess,
          renderLoading = _this$props2.renderLoading;
      var readyState = this.state.readyState;
      return _react.default.createElement(_FetchReadyStateRenderer.default, {
        error: error,
        readyState: readyState,
        renderFailure: renderFailure,
        renderLoading: renderLoading,
        renderSuccess: renderSuccess
      }, children);
    }
  }]);
  return FetchRootContainer;
}(_react.Component);

exports.FetchRootComponent = FetchRootContainer;
FetchRootContainer.displayName = 'FetchRootContainer';
FetchRootContainer.propTypes = {
  children: _propTypes.default.node.isRequired,
  error: _propTypes.default.any,
  forceInitialFetch: _propTypes.default.bool,
  onFetchRouteData: _propTypes.default.func.isRequired,
  readyState: _propTypes.default.oneOf([_ReadyState.default.FAILURE, _ReadyState.default.LOADING, _ReadyState.default.PENDING, _ReadyState.default.SUCCESS]).isRequired,
  renderFailure: _propTypes.default.func,
  renderLoading: _propTypes.default.func,
  renderSuccess: _propTypes.default.func,
  routerProps: _propTypes.default.object.isRequired
};
FetchRootContainer.defaultProps = {
  forceInitialFetch: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    error: (0, _selectors.getError)(state),
    readyState: (0, _selectors.getReadyState)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    onFetchRouteData: _actions.fetchRouteData
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FetchRootContainer); // for testing


exports.default = _default;